import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/Seo.js';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <main className="container mx-auto px-4 py-8">
      <Seo path="/privacy-policy" title={t('privacyPolicy.seo.title')} description={t('privacyPolicy.seo.description')} />
      <article>
        <h1 className="text-3xl font-bold mb-4">{t('privacyPolicy.title')}</h1>
        <p className="mb-4">
          {t('privacyPolicy.intro')}
        </p>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('privacyPolicy.section1.title')}</h2>
          <p className="mb-4">
            {t('privacyPolicy.section1.content')}
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('privacyPolicy.section2.title')}</h2>
          <p className="mb-4">
            {t('privacyPolicy.section2.content')}
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('privacyPolicy.section3.title')}</h2>
          <p className="mb-4">
            {t('privacyPolicy.section3.content')}
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('privacyPolicy.section4.title')}</h2>
          <p className="mb-4">
            {t('privacyPolicy.section4.content')}
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-bold mb-2">{t('privacyPolicy.section5.title')}</h2>
          <p className="mb-4">
            {t('privacyPolicy.section5.content')}
          </p>
        </section>
        <p>
          {t('privacyPolicy.effectiveDate')}
        </p>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
